import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink
} from 'react-router-dom';
import { Dashboard, Invoices, Login, Profile, About, Privacy, Cancellation, Shipping, ProductCategory, Product, ProductList, NewInvoice, Invoice, Receipts, NewReceipt, Customers, CustomerProfile } from './Pages';
import '../../node_modules/bootstrap/dist/css/bootstrap.css';
import '../../node_modules/bootstrap/dist/js/bootstrap.js';
import '../scss/style.scss'
import 'bootstrap'
import logo from "../assets/logo.png"
import { ActionCreators } from '../store/actionCreators';
import { RootState } from 'store/store';
import { BottomBar } from './Widgets';
import { AuthSession } from 'service/AuthSession';

function App() {
  const user = useSelector((state: RootState) => state.appdata);
  const dispatch = useDispatch();
  const [isRestoringSession, setIsRestoringSession] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;

    const restoreAuthSession = async () => {
      if (!user.isUserLoggedIn) {
        const sessionUser = await AuthSession.load();
        if (sessionUser && isMounted) {
          dispatch(ActionCreators.login(sessionUser));
        }
      }

      if (isMounted) {
        setIsRestoringSession(false);
      }
    };

    restoreAuthSession();

    return () => {
      isMounted = false;
    };
  }, [dispatch, user.isUserLoggedIn]);

  const isAuthenticated = () => {
    return user.isUserLoggedIn;
  }

  const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    if (isRestoringSession) {
      return null;
    }
    return isAuthenticated() ? children : <Login />;
  }

  return (
    <div id="app">
      <Router>
        {user.isUserLoggedIn &&
          <header className="app-topbar sticky-top">
            <div className="container">
              <div className="app-topbar-inner">
                <NavLink className="app-brand" to="/">
                  <img src={logo} width="28" height="28" alt="Artha POS" />
                  <div className="app-brand-copy">
                    <span className="app-brand-title">Artha POS</span>
                    <span className="app-brand-subtitle">Billing and collections</span>
                  </div>
                </NavLink>
              </div>
            </div>
          </header>
        }
        <div className="container">
          <div className="row" style={{ marginTop: 10, marginBottom: 60 }}>
            <Routes>
              <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/invoices" element={<PrivateRoute><Invoices /></PrivateRoute>} />
              <Route path="/receipts" element={<PrivateRoute><Receipts /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
              <Route path="/invoice/new" element={<PrivateRoute><NewInvoice /></PrivateRoute>} />
              <Route path="/invoice/:id" element={<PrivateRoute><Invoice /></PrivateRoute>} />
              <Route path="/receipt/new" element={<PrivateRoute><NewReceipt /></PrivateRoute>} />
              <Route path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
              <Route path="/customer/:id" element={<PrivateRoute><CustomerProfile /></PrivateRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cancellation" element={<Cancellation />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/productCategory" element={<ProductCategory />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/product" element={<Product />} />
            </Routes>
          </div>
        </div>
        {user.isUserLoggedIn &&
          <BottomBar />
        }
      </Router>
    </div>
  );
}

export default App;
